import { useMemo } from 'react';
import { useAppSelector } from '../../../redux/reduxHooks';
import styles from './EmailForwardValidation.module.scss';
import { EmailOtpSteps, forwardEmailQueueStatus, IIntegrationPartner } from '../../../interfaces/interfaces';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { RiErrorWarningFill as ErrorIcon } from 'react-icons/ri'
import { ipShortNames, meritoHelpDeskEmail, TextCopy } from './emailOtpHelper';

type Props = {
    formDetails: {
        email: string,
        emailClient: string,
    },
    emailOtpSteps: {
        currentStep: number,
        previousStep: number,
    },
    ip: IIntegrationPartner,
    setEmailOtpSteps: React.Dispatch<React.SetStateAction<{
        currentStep: number,
        previousStep: number,
    }>>,
}

const EmailForwardValidation = ({ formDetails, setEmailOtpSteps, emailOtpSteps, ip }: Props) => {

    const { forwardEmailQueue } = useAppSelector(state => state.credentialVerification)

    const shortIpName = ipShortNames[ip.companyName] ?? ip.companyName;

    const emailQueueStatus = useMemo(() => {
        if (forwardEmailQueue[formDetails?.email]) {
            return forwardEmailQueue[formDetails?.email].status
        } else {
            return null
        }
    }, [forwardEmailQueue, formDetails])

    console.log('forwardEmailQueue', forwardEmailQueue)


    return (
        <div className={styles.rootContainer}>
            {emailQueueStatus == forwardEmailQueueStatus.inProgress ?
                <div className={styles.loaderRootContainer}>
                    <div className={styles.loaderContainer}>
                        <CircularLoader width='2.75rem' height='2.75rem' />
                    </div>
                    <div className={styles.textContainer}>
                        <div>
                            This may take up to 2 minutes.
                        </div>
                        <div>
                            Do not close this window.
                        </div>
                    </div>
                </div>
                :
                emailQueueStatus == forwardEmailQueueStatus.success ?
                    <div className={styles.successRootContainer}>
                        <div className={styles.title}>
                            Forwarding Address Set!
                        </div>
                        <div className={styles.subTitle}>
                            Next, set up a filter to forward only { } OTP emails.
                        </div>
                        <div className={styles.buttonContainer}>
                            <MeritoButton
                                type="primary-1"
                                size="lg"
                                btnText="Next"
                                isRounded={true}
                                onClick={() => setEmailOtpSteps(prev => ({
                                    currentStep: prev.currentStep + 1,
                                    previousStep: prev.currentStep,
                                }))}
                            />
                        </div>
                    </div>
                    : emailQueueStatus == forwardEmailQueueStatus?.failure ?
                        <div className={styles.failureRootContainer}>
                            <div className={styles.titleContainer}>
                                <div className={styles.iconContainer}>
                                    <ErrorIcon />
                                </div>
                                <div className={styles.title}>
                                    Forwarding Setup Failed!
                                </div>
                            </div>
                            <div className={styles.subTitleContainer}>
                                <div className={styles.subTitle}>
                                    <div>We couldn’t verify </div>
                                    <TextCopy text={meritoHelpDeskEmail} />
                                    <div>as a forwarding address.</div>
                                </div>
                            </div>
                            <div className={styles.listContainer}>
                                <div className={styles.listTitle}>
                                    Check your email settings:
                                </div>
                                <ol className={styles.listItem}>
                                    <li>Go to the <b>Forwarding section</b> in your email settings.</li>
                                    <li>Make sure <b>{meritoHelpDeskEmail}</b> is added.</li>
                                </ol>
                            </div>
                            <div className={styles.imgContainer}>
                                <img src={"https://assets.clickmerito.com/emailOtpSteps/emailforwardError.png?q=1"} alt="" />
                            </div>
                            <div className={styles.subTitleContainer}>
                                <div className={styles.subTitle}>
                                    <div>
                                        If the forwarding address is added and the error persists, contact Merito.
                                    </div>
                                </div>
                            </div>
                            <div className={styles.buttonContainer}>
                                <MeritoButton
                                    type="primary-1"
                                    size="lg"
                                    btnText="Setup Again"
                                    isRounded={true}
                                    onClick={() => {
                                        setEmailOtpSteps(prev => ({
                                            currentStep: EmailOtpSteps.credential,
                                            previousStep: prev.currentStep,
                                        }));
                                    }} />
                            </div>
                        </div>
                        :
                        null}
        </div>
    );
}

export default EmailForwardValidation;